import "../campaign.css";
import React, { useState } from "react";


export default function DetailNomineeSortableTable({ data, setData, categoryName }) {
    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: "asc" });

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];
        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return (<svg width="10" height="10" viewBox="0 0 10 10">
            </svg>);
        }
        return sortConfig.direction === "asc" ? (
            <svg width="10" height="10" viewBox="0 0 10 10">
                <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
            </svg>
        ) : (
            <svg width="10" height="10" viewBox="0 0 10 10">
                <path d="M0 4 L5 9 L10 4 Z" fill="#999" />
            </svg>
        );
    };

    const TrashIcon = () => (
        <svg
            width="16"
            height="16"
            fill="orangered"
            viewBox="0 0 24 24"
            style={{ cursor: "pointer" }}
        >
            <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z" />
        </svg>
    );

    const handleDelete = (index) => {
        if (window.confirm("Are you sure you want to delete this row?")) {
            const newData = [...data];
            newData.splice(index, 1);
            setData(newData);
        }
    };

    return (
        <table className="styled-table">
            <thead>
                <tr>
                    <th onClick={() => handleSort("name")}>
                        Name {getSortIcon("name")}
                    </th>
                    <th onClick={() => handleSort("sap_no")}>
                        SAP No {getSortIcon("sap_no")}
                    </th>
                    <th onClick={() => handleSort("bc_no")}>
                        BC No {getSortIcon("bc_no")}
                    </th>
                    <th onClick={() => handleSort("ig")}>
                        Section/Group {getSortIcon("ig")}
                    </th>
                    <th onClick={() => handleSort("fmp_commendation")} width="150px">
                        {categoryName} {getSortIcon("fmp_commendation")}
                    </th>
                    <th onClick={() => handleSort("remark")}>
                        Remark {getSortIcon("remark")}
                    </th>
                    <th onClick={() => handleSort("status")}>Status {getSortIcon("status")}</th>
                </tr>
            </thead>
            <tbody>
                {sortedData.map((row, index) => (
                    <tr key={index}>
                        <td>{row.name}</td>
                        <td>{row.sap_no || '-'}</td>
                        <td>{row.bc_no}</td>
                        <td>{row.ig}</td>
                        <td>{row.fmp_commendation}</td>
                        <td>{row.remark || ''}</td>
                        <td className={row.status == 'Accepted' ? "campaigns-accept-label" : "campaigns-reject-label"}>{row.status}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}